export default "__VITE_ASSET__B21vA5XM__"